import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {FIELD_LIST_CRM_SETTING_HEADER_SLIDING_TEXT} from "../../utils/input-field-list-static-page";
import React, {useEffect} from "react";
import {setCRMSettingsErrorMessage, setCRMSettingsHeaderSlidingTextDetail} from "../../reducers/crm-settings.reducer";
import {convertErrorMessage, randomCode} from "../../utils/general-variable";
import {cloneDeep} from "lodash";
import FormItemComponent from "../../components/static-page/form-item.component";
import Item from "./item";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";

const HeaderSlidingText = () => {
    const dispatch = useDispatch()
    const {headerSlidingTextDetail} = useSelector(state => state.crmSettingsReducer)
    const {fetching: getHeaderSlidingText} = useFetch(API.CRM_SETTINGS_GET_HEADER_SLIDING_TEXT)
    const {fetching: updateHeaderSlidingText, isLoading} = useFetch(API.CRM_SETTINGS_UPDATE_HEADER_SLIDING_TEXT)
    const itemList = [...headerSlidingTextDetail.texts]
    let fieldList = FIELD_LIST_CRM_SETTING_HEADER_SLIDING_TEXT
    let showHeaderSlidingText = {
        label: 'Header Sliding Text',
        key: 'is_show',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setCRMSettingsHeaderSlidingTextDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'text').toString(),
            description: null,
            title: null,
            url: null
        })
        dispatch(setCRMSettingsHeaderSlidingTextDetail({texts: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(headerSlidingTextDetail.texts)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataSlider = {...headerSlidingTextDetail, texts: dataItemList}
        updateHeaderSlidingText(dataSlider).then(response => {
            dispatch(setCRMSettingsErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Header Sliding Text Updated'))
            dispatch(setCRMSettingsHeaderSlidingTextDetail({...response?.data, delete_ids: []}))
        }).catch(err => {
            dispatch(setCRMSettingsErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getHeaderSlidingText().then(response => {
            if (response?.data?.texts?.length > 0) {
                dispatch(setCRMSettingsHeaderSlidingTextDetail({...response?.data, delete_ids: []}))
            } else {
                const data = response?.data
                delete data?.texts
                dispatch(setCRMSettingsHeaderSlidingTextDetail({...data, delete_ids: []}))
            }
        })

        return () => {
            dispatch(setCRMSettingsErrorMessage({}))
        }
    }, [])

    return (
        <div className={"px-10 py-5"}>
            <FormItemComponent
                data={headerSlidingTextDetail}
                switchToggleField={showHeaderSlidingText}
                itemList={itemList}
                objectName={'texts'}
                content={(index) => <Item fieldList={fieldList} index={index}/>}
                onChange={onChange}
                setDataList={setCRMSettingsHeaderSlidingTextDetail}
                deleteList={headerSlidingTextDetail?.delete_ids}
                addItemHandler={addItemHandler}
                onSubmitHandler={onSubmitHandler}
                isLoading={isLoading}
            />
        </div>
    )
}

export default HeaderSlidingText
